import React from 'react';
import { useSettings } from 'app/main/components';
import { ViewTable } from 'app/main/components/page-layouts';
import { type ViewPageContentTabProps } from 'app/main/components/page-layouts/view/ViewPage';

import getInvoicesTableColumns from '../InvoicesTableColumns';

export default function InvoicesTableTab(props: ViewPageContentTabProps) {
	const { settings, t } = useSettings('invoices');

	const columns = getInvoicesTableColumns({ settings, t, updateRefresh: props.updateRefresh || (() => {}) });

	return (
		<ViewTable
			id="invoicesView"
			module="invoices"
			columns={columns}
			refresh={props.refresh}
			updateRefresh={props.updateRefresh}
		/>
	);
}
